import { makeStyles } from '@material-ui/core/styles'
import AccordionBase from '../../../2compounds/AccordionBase'
import useDataList from './useDataList'
import { Reorder } from 'framer-motion'
import React from 'react'

/**
 * Data List widget component mainly used in Places tab
 * @param editMode boolean
 * @param admin boolean
 * @param data
 * @param index number
 * @param formikProps
 * @param resetToDefault
 * @param reorderFields
 * @param missingDataFieldVisibility
 * @param toggleIsHidden
 * @param updateFieldLabel
 * @param updateDataType
 * @param updateCardLabel
 * @param isCardDirty
 * @param toggleDeleteConfirmationModal
 * @param toggleIsHiddenCard
 */

const DataList = ({
  editMode,
  admin,
  data,
  index,
  formikProps,
  resetToDefault,
  layoutDefaultData,
  reorderFields,
  missingDataFieldVisibility,
  toggleIsHidden,
  updateFieldLabel,
  updateDataType,
  updateCardLabel,
  isCardDirty,
  toggleDeleteConfirmationModal,
  toggleIsHiddenCard
}) => {
  const classes = useStyles({ editMode, admin })
  const { label, cardData } = data
  const { viewSwitcher, isOpen, setIsOpen } = useDataList()
  return (
    <AccordionBase
      label={label}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      updateCardLabel={newValue => updateCardLabel(index, newValue)}
      className={classes.root}
      admin={admin}
      index={index}
      data={data}
      resetToDefault={resetToDefault}
      layoutDefaultData={layoutDefaultData}
      isCardDirty={isCardDirty}
      toggleIsHiddenCard={toggleIsHiddenCard}
    >
      <Reorder.Group
        axis='y'
        values={cardData}
        onReorder={newValue => reorderFields(newValue, index)}
        className={classes.cardInnerDiv}
        layoutScroll
      >
        {cardData.map(
          (item, fieldIndex) =>
            !item.isArchived &&
            ((missingDataFieldVisibility && item.fieldData) ||
              editMode ||
              !missingDataFieldVisibility ||
              admin) && (
              <React.Fragment key={item.fieldId}>
                {viewSwitcher(
                  item,
                  fieldIndex,
                  editMode,
                  admin,
                  classes,
                  index,
                  formikProps,
                  reorderFields,
                  toggleIsHidden,
                  updateFieldLabel,
                  updateDataType,
                  isCardDirty,
                  toggleDeleteConfirmationModal
                )}
              </React.Fragment>
            )
        )}
      </Reorder.Group>
    </AccordionBase>
  )
}

export default DataList

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    gridColumn: 'span 4',
    gridRow: 'span 4',
    border: props =>
      props.admin ? `1px dashed ${theme.palette.tertiary.main}` : 'none'
  },
  reorderInnerDiv: {
    display: 'flex',
    alignItems: 'center',
    '&>*': {
      margin: '5px 5px 0 0'
    }
  },
  reorderGroupDiv: {
    padding: 0,
    maxHeight: 150,
    overflowY: 'auto'
  },

  reorderInnerDivHidden: {
    '& .MuiFormControl-root': {
      opacity: 0.6
    }
  },
  textWrap: {
    overflowWrap: 'anywhere'
  },
  cardInnerDiv: {
    margin: 0,
    padding: '10px 0 0',
    height: '100%',
    maxHeight: 'calc((88vh - 290px) / 3)',
    overflowY: 'auto'
  }
}))
